import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deleteCalculationService } from 'modules/accommodations/features/reservations/api/deleteCalculationService';

export const useDeleteCalculationServiceMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(deleteCalculationService, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_SERVICES, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE, {
        refetchInactive: true,
      });
      successToast(t('Service is successfully deleted'));
    },
    onError: () => errorToast(),
  });
};
